import { inject, Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class LoginRedirectService {
    private router = inject(Router);

    remember(state: RouterStateSnapshot, targetUrl = '/sign-in') {
        const url = this.router.parseUrl(targetUrl);
        url.queryParams = {
            afterLogin: state.url,
        };
        return url;
    }

    retrieve(state: ActivatedRouteSnapshot): UrlTree {
        return this.router.parseUrl(
            state.queryParams.afterLogin || '/dashboard'
        );
    }
}
